module.exports = __webpack_public_path__ + "img/badge_assistenza.5d44b4cb.jpg";